import {AmsDataGridColumnDef} from "../framework/component/data-grid/AmsDataGrid";
import React from "react";
import {CollaboratorInvitationSummary} from "./model/CollaboratorInvitationSummary";
import {CollaboratorType} from "./model/CollaboratorType";
import {InstituteSummary} from "./model/InstituteSummary";
import {DateUtil} from "../framework/util/DateUtil";
import {Button} from "react-bootstrap";

const headerClassName = 'grid-header';

const collabTypeLabels: Record<number, string> = {
  2: CollaboratorType.Lead.label,
  3: CollaboratorType.Collaborator.label
};


export type ProcessingInvitation = { id: number; action: 'resend' | 'remove' } | null;

export function createColumnDefinitions(canManageCollaborators: boolean | undefined,
                                        processing: ProcessingInvitation,
                                        handleResendInvitation: (n: number) => void,
                                        handleRemoveInvitation: (n: number) => void,
                                        institutes: InstituteSummary[]): AmsDataGridColumnDef[] {
  return [
    {
      field: 'email',
      headerName: 'Email address',
      flex: 1,
      minWidth: 200,
      filterable: false,
      headerClassName: headerClassName
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 120,
      filterable: false,
      headerClassName: headerClassName,
      valueGetter: (_value: unknown, row: CollaboratorInvitationSummary) =>
        row.invitationDisplayStatus
    },
    {
      field: 'instituteId',
      headerName: 'Institute',
      flex: 1,
      minWidth: 200,
      filterable: false,
      headerClassName: headerClassName,
      valueGetter: (value: number, row: CollaboratorInvitationSummary) => {
        const institute = institutes.find(i => i.instituteId === row.instituteId);
        return institute?.name ?? '';
      }
    },
    {
      field: 'collabType',
      headerName: 'Collaborator Type',
      width: 160,
      filterable: false,
      headerClassName: headerClassName,
      valueGetter: (value: number) => collabTypeLabels[value] ?? ''
    },
    {
      field: 'delegate',
      headerName: 'Delegate',
      width: 100,
      filterable: false,
      headerClassName: headerClassName,
      valueGetter: (value: number) => value === 1 ? 'Y' : 'N'
    },
    {
      field: 'lastSentWhen',
      headerName: 'Last sent time',
      flex: 1,
      minWidth: 200,
      filterable: false,
      headerClassName: headerClassName,
      valueGetter: (value: string | number | null, row: CollaboratorInvitationSummary) => {
        return DateUtil.formatDateTimeInMillisecond(row.lastSentWhen);
      }
    },
    {
      field: 'resend',
      headerName: 'Resend link',
      width: 160,
      filterable: false,
      sortable: false,
      headerClassName: headerClassName,
      renderCell: (params: any) => {
        const isResendingThisRow = processing?.id === params.row.collaboratorInvitationId && processing?.action === 'resend';
        return (
          <Button
              variant="outline-primary"
              size="sm"
              disabled={!canManageCollaborators || processing !== null}
              onClick={() => handleResendInvitation(params.row.collaboratorInvitationId)}>
            {isResendingThisRow ? 'Sending...' : 'Resend link'}
          </Button>
        );
      }
    },
    {
      field: 'remove',
      headerName: 'Remove',
      width: 120,
      filterable: false,
      sortable: false,
      headerClassName: headerClassName,
      renderCell: (params: any) => {
        const isRemovingThisRow = processing?.id === params.row.collaboratorInvitationId && processing?.action === 'remove';
        return (
          <Button
              variant="outline-danger"
              size="sm"
              disabled={!canManageCollaborators || processing !== null}
              onClick={() => handleRemoveInvitation(params.row.collaboratorInvitationId)}>
            {isRemovingThisRow ? 'Removing...' : 'Remove'}
          </Button>
        );
      }
    }
  ];
}
